import HCLDX from "@system/config/hcldx";
import System from "../../src/helper/system";
import $ from "jquery";
import Constants from "src/helper/Constants";

let c = System.getParams();

class Order {
    static ORDER_LISTING = System.getOrderUrl() + '/api/order/amer/orderHistoryList';
    static HEADER_ORDER_DETAIL = System.getOrderUrl() + '/api/order/headerDetails';
    static ORDER_EMAIL = System.getOrderUrl() + '/api/order/emailOrder';
    static ORDER_EMAIL_SALES_REPRESENTATIVE = System.getOrderUrl() + '/api/order/emailSalesRepresentative';
    static ORDER_BY_LINE_ITEM = System.getOrderUrl() + '/api/order/orderLinesByItems';
    static ORDER_BY_DELIVERY = System.getOrderUrl() + '/api/order/orderLinesByShipments';
    static PLACE_YOUR_ORDER = System.getOrderUrl() + '/api/order/amer/placeOrder';
    static PLACE_ORDER_ITEMS = System.getOrderUrl() + '/api/order/amer/orderItems';
    static ORDER_DOWNLOAD_INVOICE = System.getCartUrl() + '/api/cart/invoice/amer/download';
    static EXPORT_ORDER = System.getOrderUrl() + '/api/order/amer/export';
    static EXPORT_EMAIL = System.getOrderUrl() + '/api/order/amer/exportEmail';
    static EXPORT_ORDER_ATTACHMENT = System.getOrderUrl() + '/api/order/exportOrderEmail';
    static ORDER_EXPORT_COUNT = System.getOrderUrl() + '/api/order/amer/OrderHistoryCount';
    static ORDER_MANUFACTURE_LIST = System.getCartUrl() + '/api/order/amer/manfacturers';
    static ORDER_LINE_ITEM_WISE_EMAIL = System.getOrderUrl() + '/api/order/lineItemwiseEmail';
    static ORDER_PO_LINE_ITEM_EMAIL = System.getOrderUrl() + '/api/order/sendOrderPOItemEmail';
    static GET_ORDER_ITEM_LIST = System.getCartUrl() + '/api/order/amer/orderItemList';
    static BILLING_CURRENCY_CONVERSION = System.getOrderUrl() + '/api/order/amer/billingCurrencyConversion';
    static ORDER_DETAIL = System.getCartUrl() + '/api/order/amer/orderHistoryOrderDetails';
    static ORDER_EMAIL_SALES = System.getCartUrl() + '/api/order/amer/sendOrderDetailsEmailToSales';
    static ORDER_ITEM_EMAIL = System.getCartUrl() + '/api/order/amer/sendOrderItemEmailToSR';
    static ORDER_CANCELLATION_EMAIL = System.getCartUrl() + '/api/order/amer/orderCancellationEmail';

    static getOrderRouteURL() {
        return HCLDX.baseURL() + '/resources/myavnet/orders';
    }

    static getOrderDetailRouteURL(extra_c = {}) {
        c['page'] = Constants.OrderPages.OrderDetail.param_value;
        return this.getURLBasedOnParamKey({
            ...c,
            ...extra_c
        });
    }

    static getOrderDetailRouteFromOrderSuccessURL(extra_c = {}) {
        let p = {}
        p['page'] = Constants.OrderPages.OrderDetail.param_value;
        return this.getURLBasedOnParamKey({
            ...p,
            ...extra_c
        });
    }

    static getOrderDetailTabsListRouteURL(extra_c = {}) {
        c['tab'] = Constants.OrderDetailTabList.BY_SHIPMENT.param_value;
        return this.getURLBasedOnParamKey({
            ...c,
            ...extra_c
        });
    }

    static getURLBasedOnParamKey(c) {
        return HCLDX.baseURL() + '/resources/myavnet/orders?' + $.param(c);
    }
}

export default Order;